<template>
	<div class="onlineMall">
		<div class="onlineMall-box">
			<div class="searchHeader">
				<div class="search-box">
					<el-input v-model="search" placeholder="请输入搜索内容" suffix-icon="el-icon-search" class="search-input"
						@keydown.enter.native="searchEnter" @blur="searchEnter" clearable>
					</el-input>
					<!-- <div class="search-btn">
						<el-button icon="el-icon-search" type="primary">搜索</el-button>
					</div> -->
				</div>
			</div>
			<el-row :gutter="20" class="commodityList">
				<el-empty description="找不到相关产品" v-if="!currentList.length"></el-empty>
				<el-col :span="6" v-for="(item,index) in currentList" :key="index"
					@click.native="goDetail(item.id,item)">
					<el-card :body-style="{ padding: '0px' }" class="commodityItem" shadow="hover">
						<img :src="item.img" class="image">
						<div class="content">
							<div class="price">
								<!-- <em>¥</em> -->
								{{item.price}}
							</div>
							<el-descriptions class="header" title="" :column="1" :colon="false">
								<el-descriptions-item label="" labelClassName="label">
									{{item.name}}
								</el-descriptions-item>
								<el-descriptions-item label="" labelClassName="label">
									<el-tag>{{item.company}}</el-tag>
									<!-- <el-tag size="small">学校</el-tag> -->
								</el-descriptions-item>
								<!-- <el-descriptions-item label="" contentClassName="summary" labelClassName="label">
									身高多少更合适的感受到国税局等各环节的更好地归属感数据结构时间规划局松岗街道松岗街道素冠荷鼎身高多少
								</el-descriptions-item> -->
								<el-descriptions-item label="" labelClassName="label">{{item.type}}
								</el-descriptions-item>
							</el-descriptions>
							<!-- <span>好吃的汉堡</span>
							<div class="bottom clearfix">
								<time class="time">11111</time>
							</div> -->
						</div>
					</el-card>
				</el-col>
			</el-row>
			<div class="pagination-box">
				<el-pagination :page-size="pageSize" :current-page.sync="pageNum" :total="total"
					@current-change="getCurrentPage" background layout="prev, pager, next, jumper" :hide-on-single-page="currentList.length ? false:true">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import './index.less';
	import data from '../onlineStore.json'
	export default {
		data() {
			return {
				search: '',
				dataList: [],
				searchList: [],
				currentList: [],
				pageSize: 8,
				total: 0,
				pageNum: 1,
				isempty:false,
			}
		},
		methods: {
			goDetail(id, content) {
				this.$router.push({
					path: `/onlineMallDetail/${id}`,
					query: content
				})
			},
			searchEnter() {
				if (this.search == '') {
					this.dataList = data.data
					this.total = this.dataList.length
					this.currentList = this.dataList.slice(0, 8)
					this.pageNum = 1
				} else {
					this.dataList = []
					data.data.map((item, index) => {
						if (item.name.includes(this.search)) {
							this.dataList.push(item)
						}
					})
					this.total = this.dataList.length
					this.currentList = this.dataList.slice(0, 8)
					this.pageNum = 1
				}
				console.log(this.currentList)
			},
			getCurrentPage(num) {
				this.pageNum = num
				this.currentList = this.dataList.slice(8 * (num - 1), 8 * (num))
			}
		},
		computed: {

		},
		mounted() {
			this.dataList = data.data
			this.total = this.dataList.length
			this.currentList = this.dataList.slice(0, 8)
			console.log(this.currentList != [])
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/onlineMall/onlineMallList/index.vue